import React, {useState} from 'react';
import Background from '../Background';
import Button from '../Button';
import Rodal from 'rodal';
import cx from 'classnames';
import CtaPlaceholder from '../../assets/images/magic-cta-placeholder.png';
import './Magic.css';

function Magic({data, onGotoParty, onGotoRecord, className, ...otherProps}) {
  const {
    ctaLuckyDrawBtnThumbnail,
    ctaLuckyDrawBtnImage,
    ctaMyRecordBtnThumbnail,
    ctaMyRecordBtnImage,
    hideMagicSuppriseButton,
    hideMyRecordButton,
    hideMagicSuppriseSection
  } = data;

  return hideMagicSuppriseSection ? null : (
    <div className={cx('ha-magic-surprise', className)} {...otherProps}>
      {/* <img className='star2' src={Star2} alt="" />
      <img className='star3' src={Star3} alt="" /> */}
      <div className='contents'>
        {
          !hideMagicSuppriseButton && !hideMagicSuppriseSection &&
          <Background className='magic-button' onClick={onGotoParty} src={ctaLuckyDrawBtnImage} placeholder={ctaLuckyDrawBtnThumbnail}>
            <img src={CtaPlaceholder} alt=""/>
          </Background>
        }
        {
          !hideMyRecordButton && !hideMagicSuppriseSection &&
          <Background className='record-button' onClick={onGotoRecord} src={ctaMyRecordBtnImage} placeholder={ctaMyRecordBtnThumbnail}>
            <img src={CtaPlaceholder} alt=""/>
          </Background>
        }

      </div>
    </div>
  )
}

export default Magic;

// {
//   termAndServiceLinkText &&
//   <div className='terms' style={{color: termAndServiceLinkFontColor}} onClick={toggleTerms}>
//     <span>{termAndServiceLinkText}</span>
//   </div>
// }
